<template>
  <div>
      <b-jumbotron
    header="Notifications"
    lead="Init. Date:01/01/2020                Last Update: 01/06/2020"
    id="last-version-jumbo"
  >

      <template v-slot:lead>
        <div class="row">
             <div class="form-group col-md">
            <label for="security_credential_autentication_type_filter">Option 02</label>
            <b-form-select
              id="security_credential_autentication_type_filter"
              class="form-control"

            />
          </div>
                    <div class="form-group col-md">
            <label for="security_credential_autentication_type_filter">Option 02</label>
            <b-form-select
              id="security_credential_autentication_type_filter"
              class="form-control"
      
            />
          </div>
                    <div class="form-group col-md">
            <label for="security_credential_autentication_type_filter">Option 02</label>
            <b-form-select
              id="security_credential_autentication_type_filter"
              class="form-control"
     
            />
          </div>
        </div>

    </template>


    </b-jumbotron>

<NotificationsTab></NotificationsTab>


  </div>
</template>



<script>
/** COMPONENTS - LAYOUT **/

import NotificationsTab from  "@/modules/notifications_ds/internal/notifications/NotificationsTab";


export default {
  name: "NotificationsContainer",
  components: {  NotificationsTab },
  data: function() {
    return {};
  },
  methods: {},
  created() {
    this.$store.commit("setTypeLayout", 2);
  },
};
</script>

